import { useTranslation } from 'react-i18next';
import { NavLink, useLocation } from 'react-router';

import {
  type ContentRenderer,
  type LinkRenderer,
  renderNavNodes,
  SidebarDesktop,
  SidebarMobile,
} from '@valwin/facto/widgets';

import { useGroupInfos } from '~entities/group';
import { useProfile } from '~entities/user';
import { useIsValwinAdmin } from '~features/valwin-admin';
import { LogoSmall } from '~shared/ui';

import { useNavigationItems } from './useNavigationItems';

const linkRenderer: LinkRenderer = (to) => {
  const NavLinkRenderer: ContentRenderer = (content) => (
    <NavLink to={to}>{content}</NavLink>
  );

  return NavLinkRenderer;
};

function useNavItems() {
  const { profile } = useProfile();
  const { isLoading: isFeaturesLoading } = useGroupInfos();
  const { isValwinAdmin, isLoading: isValwinAdminLoading } = useIsValwinAdmin();
  const items = useNavigationItems({
    isAdmin: !!profile?.isAdmin,
    isValwinAdmin,
  });

  return { items, isLoading: isFeaturesLoading || isValwinAdminLoading };
}

export function SidebarNavDesktop() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  const { items, isLoading } = useNavItems();

  return (
    <SidebarDesktop.Root>
      <SidebarDesktop.Menu>
        {isLoading ? (
          <SidebarDesktop.Skeleton />
        ) : (
          renderNavNodes({ nodes: items, pathname, renderLink: linkRenderer })
        )}
      </SidebarDesktop.Menu>
      <SidebarDesktop.Footer
        expandLabel={t('sidebar expand')}
        collapseLabel={t('sidebar collapse')}
      />
    </SidebarDesktop.Root>
  );
}

export function SidebarNavMobile() {
  const { pathname } = useLocation();
  const { items } = useNavItems();

  return (
    <SidebarMobile
      nodes={items}
      pathname={pathname}
      renderLink={linkRenderer}
      logo={<LogoSmall />}
    />
  );
}
